/**
 * TanStack Query hooks for `custom-partner-email-sender-domain-smtp-relay-per`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customPartnerEmailSenderDomainSmtpRelayPerQueryKeys,
	type CreateCustomPartnerEmailSenderDomainSmtpRelayPerBody,
	type ListCustomPartnerEmailSenderDomainSmtpRelayPerResponse,
	type CustomPartnerEmailSenderDomainSmtpRelayPerRow,
} from "./api";

export function useCustomPartnerEmailSenderDomainSmtpRelayPerList(): UseQueryResult<ListCustomPartnerEmailSenderDomainSmtpRelayPerResponse, Error> {
	return useQuery({
		queryKey: customPartnerEmailSenderDomainSmtpRelayPerQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomPartnerEmailSenderDomainSmtpRelayPerCreate(): UseMutationResult<CustomPartnerEmailSenderDomainSmtpRelayPerRow, Error, CreateCustomPartnerEmailSenderDomainSmtpRelayPerBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customPartnerEmailSenderDomainSmtpRelayPerQueryKeys.all });
		},
	});
}

export function useCustomPartnerEmailSenderDomainSmtpRelayPerDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customPartnerEmailSenderDomainSmtpRelayPerQueryKeys.all });
		},
	});
}
